import { useDataSubmit, useDataValue } from 'Simple/Data.js'
export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let connection_id = useDataValue({
    context: 'connection',
    viewPath: props.viewPath,
    path: 'id',
  })
  return function onClick() {
    props.closePopover?.()

    submit({
      type: 'sync',
      connection_id,
    })
  }
}
